export function FallbackView() {
  return (
    <div className="splash-screen">
      <span>Loading ...</span>
    </div>
  );
}
